import { Col, Grid, RSelect, Separator, Title } from '@common/components';
import { AccordionItem } from '@common/components/AccordionItem/AccordionItem';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import viewClasses from './ClassFilters.module.scss';

export default function ClassFilters({
  centerClassesMap,
  centers,
  selectedCenterClassesMap,
  onChangeSelectedClasses,
}) {
  const { t } = useTranslation('dashboard\\ClassFilters');

  const centerClasses = useMemo(() => {
    const result = [];

    if (!centerClassesMap) {
      return result;
    }

    centers.forEach((center) => {
      const classes = centerClassesMap[center.uuid];
      if (classes) {
        result.push({
          center: { ...center },
          classes: classes.map((cls) => ({
            label: cls.className,
            value: cls.classId,
          })),
        });
      }
    });

    return result;
  }, [centerClassesMap, centers]);

  const selectedClassesCount = useMemo(() => {
    return Object.values(selectedCenterClassesMap).reduce((count, classes) => {
      return count + classes.length;
    }, 0);
  }, [selectedCenterClassesMap]);

  const handleChangeSelectedClasses = (center, selectedClassesOfCenter) => {
    onChangeSelectedClasses({
      ...selectedCenterClassesMap,
      [center.uuid]: selectedClassesOfCenter,
    });
  };

  return (
    <>
      <Title type="h3" color="grey-400">
        {t('filtersTitle')}
      </Title>
      <AccordionItem
        label={`${t('selectedClasses', {
          count: selectedClassesCount,
        })}`}
        className={viewClasses.accordionItem}
      >
        {centerClasses.map((cls) => (
          <Grid key={cls.center.uuid} className={viewClasses.centerRow}>
            <Col xss={12} xs={12} sm={3}>
              <Title type="span">{cls.center.name}</Title>
            </Col>
            <Col xss={12} xs={12} sm={3}>
              <RSelect
                isMultiple
                data={cls.classes}
                val={selectedCenterClassesMap[cls.center.uuid] || []}
                onChange={(value) => {
                  handleChangeSelectedClasses(cls.center, value);
                }}
              />
            </Col>
          </Grid>
        ))}
        <Separator />
      </AccordionItem>
    </>
  );
}

ClassFilters.propTypes = {
  centerClassesMap: PropTypes.object.isRequired,
  centers: PropTypes.array.isRequired,
  selectedCenterClassesMap: PropTypes.object.isRequired,
  onChangeSelectedClasses: PropTypes.func.isRequired,
};
